import { createContext } from 'react';
import type { VtkAnnotation, SegmentPointPositionTuple } from '../types';

// @ts-expect-error [EN-10263] - TS2322 - Type 'Context<{ updateAnnotation: null; updateAnnotationBatch: null; deleteAnnotation: null; updateAnnotationSegments: null; }>' is not assignable to type 'Context<{ updateAnnotation: (id: string) => (annotation: Partial<VtkAnnotation>) => Promise<undefined> | null | undefined; updateAnnotationBatch: ((filterer: (annotation: VtkAnnotation) => boolean, updater: (annotation: VtkAnnotation) => Partial<...>) => void | Promise<...>) | ... 1 more ... | undefined; updateAnnot...'.
export const AnnotationMutationsContext: React.Context<{
  updateAnnotation: (
    id: string
  ) => (annotation: Partial<VtkAnnotation>) => Promise<undefined> | undefined | null | undefined;
  updateAnnotationBatch:
    | ((
        filterer: (annotation: VtkAnnotation) => boolean,
        updater: (annotation: VtkAnnotation) => Partial<VtkAnnotation>
      ) => Promise<void> | void)
    | null
    | undefined;
  updateAnnotationSegments: (
    arg1: string,
    arg2?: boolean | null | undefined
  ) => (arg1: Array<SegmentPointPositionTuple>) => Promise<unknown> | undefined | null | undefined;
  deleteAnnotation: (arg1: string) => Promise<unknown> | undefined | null | undefined;
}> = createContext({
  updateAnnotation: null,
  updateAnnotationBatch: null,
  deleteAnnotation: null,
  updateAnnotationSegments: null,
});
